import { useState, type ReactNode, type SyntheticEvent } from "react";

/**
 * Значок «?» с всплывающим пояснением. Открывается наведением, фокусом с клавиатуры или касанием.
 * Клик не всплывает: подсказки стоят и внутри строк-ссылок сканера.
 */
export function Hint({
  children,
  label = "Пояснение",
  align = "start",
}: {
  children: ReactNode;
  label?: string;
  align?: "start" | "end";
}) {
  // Раскладка страницы резиновая: подсказка у правого края разворачивается влево, если иначе вышла бы за экран.
  const [side, setSide] = useState(align);
  const place = (e: SyntheticEvent<HTMLSpanElement>) => {
    const r = e.currentTarget.getBoundingClientRect();
    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 15.3;
    const popW = Math.min(21 * rem, window.innerWidth - 32); // как max-width у .hint-pop
    setSide(align === "end" || r.left - 10 + popW > window.innerWidth - 8 ? "end" : "start");
  };
  return (
    <span
      className={`hint hint-${side}`}
      tabIndex={0}
      role="button"
      aria-label={label}
      onMouseEnter={place}
      onFocus={place}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <span className="hint-icon" aria-hidden="true">
        ?
      </span>
      <span className="hint-pop" role="tooltip">
        {children}
      </span>
    </span>
  );
}

/** Подпись с подсказкой: «Текст ?». */
export function Labeled({ children, hint, align }: { children: ReactNode; hint: ReactNode; align?: "start" | "end" }) {
  return (
    <span className="labeled">
      {children}
      <Hint align={align}>{hint}</Hint>
    </span>
  );
}
